import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import { useStore } from "csi/state/hooks";
import xml from "csi/xml";
import React, { FunctionComponent } from "react";

const ConnectedIcon = (props) => {
	return (
		<SvgIcon
			viewBox="0 0 24 24"
			{...props}
		>
			<path d="M22 11V15C22 16.657 20.657 18 19 18C17.343 18 16 16.657 16 15V10H21C21.5525 10 22 10.4475 22 11ZM19 8C20.1045 8 21 7.1045 21 6C21 4.8955 20.1045 4 19 4C17.8955 4 17 4.8955 17 6C17 7.1045 17.8955 8 19 8Z" fill="#5059C9" />
			<path d="M17.5 11V16.5C17.5 19.3715 15.0795 21.678 12.167 21.489C9.5095 21.317 7.5 18.9915 7.5 16.3285V10H16.5C17.0525 10 17.5 10.4475 17.5 11ZM12.5 8.5C14.157 8.5 15.5 7.157 15.5 5.5C15.5 3.843 14.157 2.5 12.5 2.5C10.843 2.5 9.5 3.843 9.5 5.5C9.5 7.157 10.843 8.5 12.5 8.5Z" fill="#7B83EB" />
			<path d="M12.5 8.5C14.1569 8.5 15.5 7.15685 15.5 5.5C15.5 3.84315 14.1569 2.5 12.5 2.5C10.8431 2.5 9.5 3.84315 9.5 5.5C9.5 7.15685 10.8431 8.5 12.5 8.5Z" fill="#7B83EB" />
			<path
				d="M13 16.6595V10H7.5V16.3285C7.5 17.0955 7.6715 17.8325 7.972 18.5H11.159C12.176 18.5 13 17.676 13 16.6595Z"
				fill="black"
				opacity="0.05"
			/>
			<path
				d="M7.5 10V16.3285C7.5 16.9085 7.6005 17.4705 7.777 18H11.106C11.968 18 12.6665 17.3015 12.6665 16.4395V10H7.5Z"
				fill="black"
				opacity="0.07"
			/>
			<path
				d="M12.3335 10H7.5V16.3285C7.5 16.7295 7.5505 17.1205 7.637 17.5H11.053C11.76 17.5 12.333 16.927 12.333 16.22V10H12.3335Z"
				fill="black"
				opacity="0.09"
			/>
			<path d="M11 17H3C2.4475 17 2 16.5525 2 16V8C2 7.4475 2.4475 7 3 7H11C11.5525 7 12 7.4475 12 8V16C12 16.5525 11.5525 17 11 17Z" fill="url(#paint0_linear_6340_7410)" />
			<path d="M9.03382 9.49951H4.96582V10.3595H6.48932V14.4995H7.51032V10.3595H9.03382V9.49951Z" fill="white" />
			<defs>
				<linearGradient
					gradientUnits="userSpaceOnUse"
					id="paint0_linear_6340_7410"
					x1="2.324"
					x2="11.7015"
					y1="7.324"
					y2="16.7015"
				>
					<stop stopColor="#5961C3" />
					<stop offset="1" stopColor="#3A41AC" />
				</linearGradient>
			</defs>
		</SvgIcon>
	);
};

const ArcticFresh = () => {
	return (
		<SvgIcon viewBox="0 0 24 24">
			<path d="M22 11V15C22 16.657 20.657 18 19 18C17.343 18 16 16.657 16 15V10H21C21.5525 10 22 10.4475 22 11ZM19 8C20.1045 8 21 7.1045 21 6C21 4.8955 20.1045 4 19 4C17.8955 4 17 4.8955 17 6C17 7.1045 17.8955 8 19 8Z" fill="#2D76D4" />
			<path d="M17.5 11V16.5C17.5 19.3715 15.0795 21.678 12.167 21.489C9.5095 21.317 7.5 18.9915 7.5 16.3285V10H16.5C17.0525 10 17.5 10.4475 17.5 11ZM12.5 8.5C14.157 8.5 15.5 7.157 15.5 5.5C15.5 3.843 14.157 2.5 12.5 2.5C10.843 2.5 9.5 3.843 9.5 5.5C9.5 7.157 10.843 8.5 12.5 8.5Z" fill="#61A7F2" />
			<path d="M12.5 8.5C14.1569 8.5 15.5 7.15685 15.5 5.5C15.5 3.84315 14.1569 2.5 12.5 2.5C10.8431 2.5 9.5 3.84315 9.5 5.5C9.5 7.15685 10.8431 8.5 12.5 8.5Z" fill="#61A7F2" />
			<path
				d="M13 16.6595V10H7.5V16.3285C7.5 17.0955 7.6715 17.8325 7.972 18.5H11.159C12.176 18.5 13 17.676 13 16.6595Z"
				fill="black"
				opacity="0.05"
			/>
			<path
				d="M7.5 10V16.3285C7.5 16.9085 7.6005 17.4705 7.777 18H11.106C11.968 18 12.6665 17.3015 12.6665 16.4395V10H7.5Z"
				fill="black"
				opacity="0.07"
			/>
			<path
				d="M12.3335 10H7.5V16.3285C7.5 16.7295 7.5505 17.1205 7.637 17.5H11.053C11.76 17.5 12.333 16.927 12.333 16.22V10H12.3335Z"
				fill="black"
				opacity="0.09"
			/>
			<path d="M11 17H3C2.4475 17 2 16.5525 2 16V8C2 7.4475 2.4475 7 3 7H11C11.5525 7 12 7.4475 12 8V16C12 16.5525 11.5525 17 11 17Z" fill="#2D76D4" />
			<path d="M9.03382 9.49951H4.96582V10.3595H6.48932V14.4995H7.51032V10.3595H9.03382V9.49951Z" fill="white" />
		</SvgIcon>
	);
};

const CentricBlue = () => {
	return (
		<SvgIcon viewBox="0 0 24 24">
			<path d="M22 11V15C22 16.657 20.657 18 19 18C17.343 18 16 16.657 16 15V10H21C21.5525 10 22 10.4475 22 11ZM19 8C20.1045 8 21 7.1045 21 6C21 4.8955 20.1045 4 19 4C17.8955 4 17 4.8955 17 6C17 7.1045 17.8955 8 19 8Z" fill="#2D76D4" />
			<path d="M17.5 11V16.5C17.5 19.3715 15.0795 21.678 12.167 21.489C9.5095 21.317 7.5 18.9915 7.5 16.3285V10H16.5C17.0525 10 17.5 10.4475 17.5 11ZM12.5 8.5C14.157 8.5 15.5 7.157 15.5 5.5C15.5 3.843 14.157 2.5 12.5 2.5C10.843 2.5 9.5 3.843 9.5 5.5C9.5 7.157 10.843 8.5 12.5 8.5Z" fill="#61A7F2" />
			<path d="M12.5 8.5C14.1569 8.5 15.5 7.15685 15.5 5.5C15.5 3.84315 14.1569 2.5 12.5 2.5C10.8431 2.5 9.5 3.84315 9.5 5.5C9.5 7.15685 10.8431 8.5 12.5 8.5Z" fill="#61A7F2" />
			<path
				d="M13 16.6595V10H7.5V16.3285C7.5 17.0955 7.6715 17.8325 7.972 18.5H11.159C12.176 18.5 13 17.676 13 16.6595Z"
				fill="black"
				opacity="0.05"
			/>
			<path
				d="M7.5 10V16.3285C7.5 16.9085 7.6005 17.4705 7.777 18H11.106C11.968 18 12.6665 17.3015 12.6665 16.4395V10H7.5Z"
				fill="black"
				opacity="0.07"
			/>
			<path
				d="M12.3335 10H7.5V16.3285C7.5 16.7295 7.5505 17.1205 7.637 17.5H11.053C11.76 17.5 12.333 16.927 12.333 16.22V10H12.3335Z"
				fill="black"
				opacity="0.09"
			/>
			<path d="M11 17H3C2.4475 17 2 16.5525 2 16V8C2 7.4475 2.4475 7 3 7H11C11.5525 7 12 7.4475 12 8V16C12 16.5525 11.5525 17 11 17Z" fill="#2D76D4" />
			<path d="M9.03382 9.49951H4.96582V10.3595H6.48932V14.4995H7.51032V10.3595H9.03382V9.49951Z" fill="white" />
		</SvgIcon>
	);
};

const DragonFruit = () => {
	return (
		<SvgIcon viewBox="0 0 24 24">
			<path d="M22 11V15C22 16.657 20.657 18 19 18C17.343 18 16 16.657 16 15V10H21C21.5525 10 22 10.4475 22 11ZM19 8C20.1045 8 21 7.1045 21 6C21 4.8955 20.1045 4 19 4C17.8955 4 17 4.8955 17 6C17 7.1045 17.8955 8 19 8Z" fill="#CC2D6D" />
			<path d="M17.5 11V16.5C17.5 19.3715 15.0795 21.678 12.167 21.489C9.5095 21.317 7.5 18.9915 7.5 16.3285V10H16.5C17.0525 10 17.5 10.4475 17.5 11ZM12.5 8.5C14.157 8.5 15.5 7.157 15.5 5.5C15.5 3.843 14.157 2.5 12.5 2.5C10.843 2.5 9.5 3.843 9.5 5.5C9.5 7.157 10.843 8.5 12.5 8.5Z" fill="#EB5E96" />
			<path d="M12.5 8.5C14.1569 8.5 15.5 7.15685 15.5 5.5C15.5 3.84315 14.1569 2.5 12.5 2.5C10.8431 2.5 9.5 3.84315 9.5 5.5C9.5 7.15685 10.8431 8.5 12.5 8.5Z" fill="#EB5E96" />
			<path
				d="M13 16.6595V10H7.5V16.3285C7.5 17.0955 7.6715 17.8325 7.972 18.5H11.159C12.176 18.5 13 17.676 13 16.6595Z"
				fill="black"
				opacity="0.05"
			/>
			<path
				d="M7.5 10V16.3285C7.5 16.9085 7.6005 17.4705 7.777 18H11.106C11.968 18 12.6665 17.3015 12.6665 16.4395V10H7.5Z"
				fill="black"
				opacity="0.07"
			/>
			<path
				d="M12.3335 10H7.5V16.3285C7.5 16.7295 7.5505 17.1205 7.637 17.5H11.053C11.76 17.5 12.333 16.927 12.333 16.22V10H12.3335Z"
				fill="black"
				opacity="0.09"
			/>
			<path d="M11 17H3C2.4475 17 2 16.5525 2 16V8C2 7.4475 2.4475 7 3 7H11C11.5525 7 12 7.4475 12 8V16C12 16.5525 11.5525 17 11 17Z" fill="#CC2D6D" />
			<path d="M9.03382 9.49951H4.96582V10.3595H6.48932V14.4995H7.51032V10.3595H9.03382V9.49951Z" fill="white" />
		</SvgIcon>
	);
};

const Dusk = () => {
	return (
		<SvgIcon viewBox="0 0 24 24">
			<path d="M22 11V15C22 16.657 20.657 18 19 18C17.343 18 16 16.657 16 15V10H21C21.5525 10 22 10.4475 22 11ZM19 8C20.1045 8 21 7.1045 21 6C21 4.8955 20.1045 4 19 4C17.8955 4 17 4.8955 17 6C17 7.1045 17.8955 8 19 8Z" fill="#3C485C" />
			<path d="M17.5 11V16.5C17.5 19.3715 15.0795 21.678 12.167 21.489C9.5095 21.317 7.5 18.9915 7.5 16.3285V10H16.5C17.0525 10 17.5 10.4475 17.5 11ZM12.5 8.5C14.157 8.5 15.5 7.157 15.5 5.5C15.5 3.843 14.157 2.5 12.5 2.5C10.843 2.5 9.5 3.843 9.5 5.5C9.5 7.157 10.843 8.5 12.5 8.5Z" fill="#656E80" />
			<path d="M12.5 8.5C14.1569 8.5 15.5 7.15685 15.5 5.5C15.5 3.84315 14.1569 2.5 12.5 2.5C10.8431 2.5 9.5 3.84315 9.5 5.5C9.5 7.15685 10.8431 8.5 12.5 8.5Z" fill="#656E80" />
			<path
				d="M13 16.6595V10H7.5V16.3285C7.5 17.0955 7.6715 17.8325 7.972 18.5H11.159C12.176 18.5 13 17.676 13 16.6595Z"
				fill="black"
				opacity="0.05"
			/>
			<path
				d="M7.5 10V16.3285C7.5 16.9085 7.6005 17.4705 7.777 18H11.106C11.968 18 12.6665 17.3015 12.6665 16.4395V10H7.5Z"
				fill="black"
				opacity="0.07"
			/>
			<path
				d="M12.3335 10H7.5V16.3285C7.5 16.7295 7.5505 17.1205 7.637 17.5H11.053C11.76 17.5 12.333 16.927 12.333 16.22V10H12.3335Z"
				fill="black"
				opacity="0.09"
			/>
			<path d="M11 17H3C2.4475 17 2 16.5525 2 16V8C2 7.4475 2.4475 7 3 7H11C11.5525 7 12 7.4475 12 8V16C12 16.5525 11.5525 17 11 17Z" fill="#3C485C" />
			<path d="M9.03382 9.49951H4.96582V10.3595H6.48932V14.4995H7.51032V10.3595H9.03382V9.49951Z" fill="white" />
		</SvgIcon>
	);
};

const GrayscaleIcon = () => {
	return (
		<SvgIcon viewBox="0 0 24 24">
			<path d="M22 11V15C22 16.657 20.657 18 19 18C17.343 18 16 16.657 16 15V10H21C21.5525 10 22 10.4475 22 11ZM19 8C20.1045 8 21 7.1045 21 6C21 4.8955 20.1045 4 19 4C17.8955 4 17 4.8955 17 6C17 7.1045 17.8955 8 19 8Z" fill="#79818F" />
			<path d="M17.5 11V16.5C17.5 19.3715 15.0795 21.678 12.167 21.489C9.5095 21.317 7.5 18.9915 7.5 16.3285V10H16.5C17.0525 10 17.5 10.4475 17.5 11ZM12.5 8.5C14.157 8.5 15.5 7.157 15.5 5.5C15.5 3.843 14.157 2.5 12.5 2.5C10.843 2.5 9.5 3.843 9.5 5.5C9.5 7.157 10.843 8.5 12.5 8.5Z" fill="#A3ABB8" />
			<path d="M12.5 8.5C14.1569 8.5 15.5 7.15685 15.5 5.5C15.5 3.84315 14.1569 2.5 12.5 2.5C10.8431 2.5 9.5 3.84315 9.5 5.5C9.5 7.15685 10.8431 8.5 12.5 8.5Z" fill="#A3ABB8" />
			<path
				d="M13 16.6595V10H7.5V16.3285C7.5 17.0955 7.6715 17.8325 7.972 18.5H11.159C12.176 18.5 13 17.676 13 16.6595Z"
				fill="black"
				opacity="0.05"
			/>
			<path
				d="M7.5 10V16.3285C7.5 16.9085 7.6005 17.4705 7.777 18H11.106C11.968 18 12.6665 17.3015 12.6665 16.4395V10H7.5Z"
				fill="black"
				opacity="0.07"
			/>
			<path
				d="M12.3335 10H7.5V16.3285C7.5 16.7295 7.5505 17.1205 7.637 17.5H11.053C11.76 17.5 12.333 16.927 12.333 16.22V10H12.3335Z"
				fill="black"
				opacity="0.09"
			/>
			<path d="M11 17H3C2.4475 17 2 16.5525 2 16V8C2 7.4475 2.4475 7 3 7H11C11.5525 7 12 7.4475 12 8V16C12 16.5525 11.5525 17 11 17Z" fill="#79818F" />
			<path d="M9.03406 9.49951H4.96606V10.3595H6.48956V14.4995H7.51056V10.3595H9.03406V9.49951Z" fill="white" />
		</SvgIcon>
	);
};

const Indigo = () => {
	return (
		<SvgIcon viewBox="0 0 24 24">
			<path d="M22 11V15C22 16.657 20.657 18 19 18C17.343 18 16 16.657 16 15V10H21C21.5525 10 22 10.4475 22 11ZM19 8C20.1045 8 21 7.1045 21 6C21 4.8955 20.1045 4 19 4C17.8955 4 17 4.8955 17 6C17 7.1045 17.8955 8 19 8Z" fill="#194191" />
			<path d="M17.5 11V16.5C17.5 19.3715 15.0795 21.678 12.167 21.489C9.5095 21.317 7.5 18.9915 7.5 16.3285V10H16.5C17.0525 10 17.5 10.4475 17.5 11ZM12.5 8.5C14.157 8.5 15.5 7.157 15.5 5.5C15.5 3.843 14.157 2.5 12.5 2.5C10.843 2.5 9.5 3.843 9.5 5.5C9.5 7.157 10.843 8.5 12.5 8.5Z" fill="#2D76D4" />
			<path d="M12.5 8.5C14.1569 8.5 15.5 7.15685 15.5 5.5C15.5 3.84315 14.1569 2.5 12.5 2.5C10.8431 2.5 9.5 3.84315 9.5 5.5C9.5 7.15685 10.8431 8.5 12.5 8.5Z" fill="#2D76D4" />
			<path
				d="M13 16.6595V10H7.5V16.3285C7.5 17.0955 7.6715 17.8325 7.972 18.5H11.159C12.176 18.5 13 17.676 13 16.6595Z"
				fill="#2D76D4"
				opacity="0.05"
			/>
			<path
				d="M7.5 10V16.3285C7.5 16.9085 7.6005 17.4705 7.777 18H11.106C11.968 18 12.6665 17.3015 12.6665 16.4395V10H7.5Z"
				fill="black"
				opacity="0.07"
			/>
			<path
				d="M12.3335 10H7.5V16.3285C7.5 16.7295 7.5505 17.1205 7.637 17.5H11.053C11.76 17.5 12.333 16.927 12.333 16.22V10H12.3335Z"
				fill="black"
				opacity="0.09"
			/>
			<path d="M11 17H3C2.4475 17 2 16.5525 2 16V8C2 7.4475 2.4475 7 3 7H11C11.5525 7 12 7.4475 12 8V16C12 16.5525 11.5525 17 11 17Z" fill="#194191" />
			<path d="M9.03382 9.49951H4.96582V10.3595H6.48932V14.4995H7.51032V10.3595H9.03382V9.49951Z" fill="white" />
		</SvgIcon>
	);
};

const Luxe = () => {
	return (
		<SvgIcon viewBox="0 0 24 24">
			<path d="M22 11V15C22 16.657 20.657 18 19 18C17.343 18 16 16.657 16 15V10H21C21.5525 10 22 10.4475 22 11ZM19 8C20.1045 8 21 7.1045 21 6C21 4.8955 20.1045 4 19 4C17.8955 4 17 4.8955 17 6C17 7.1045 17.8955 8 19 8Z" fill="#1D2129" />
			<path d="M17.5 11V16.5C17.5 19.3715 15.0795 21.678 12.167 21.489C9.5095 21.317 7.5 18.9915 7.5 16.3285V10H16.5C17.0525 10 17.5 10.4475 17.5 11ZM12.5 8.5C14.157 8.5 15.5 7.157 15.5 5.5C15.5 3.843 14.157 2.5 12.5 2.5C10.843 2.5 9.5 3.843 9.5 5.5C9.5 7.157 10.843 8.5 12.5 8.5Z" fill="#404754" />
			<path d="M12.5 8.5C14.1569 8.5 15.5 7.15685 15.5 5.5C15.5 3.84315 14.1569 2.5 12.5 2.5C10.8431 2.5 9.5 3.84315 9.5 5.5C9.5 7.15685 10.8431 8.5 12.5 8.5Z" fill="#404754" />
			<path
				d="M13 16.6595V10H7.5V16.3285C7.5 17.0955 7.6715 17.8325 7.972 18.5H11.159C12.176 18.5 13 17.676 13 16.6595Z"
				fill="black"
				opacity="0.05"
			/>
			<path
				d="M7.5 10V16.3285C7.5 16.9085 7.6005 17.4705 7.777 18H11.106C11.968 18 12.6665 17.3015 12.6665 16.4395V10H7.5Z"
				fill="black"
				opacity="0.07"
			/>
			<path
				d="M12.3335 10H7.5V16.3285C7.5 16.7295 7.5505 17.1205 7.637 17.5H11.053C11.76 17.5 12.333 16.927 12.333 16.22V10H12.3335Z"
				fill="black"
				opacity="0.09"
			/>
			<path d="M11 17H3C2.4475 17 2 16.5525 2 16V8C2 7.4475 2.4475 7 3 7H11C11.5525 7 12 7.4475 12 8V16C12 16.5525 11.5525 17 11 17Z" fill="#1D2129" />
			<path d="M9.03382 9.49951H4.96582V10.3595H6.48932V14.4995H7.51032V10.3595H9.03382V9.49951Z" fill="white" />
		</SvgIcon>
	);
};

const OceanWave = () => {
	return (
		<SvgIcon viewBox="0 0 24 24">
			<path d="M22 11V15C22 16.657 20.657 18 19 18C17.343 18 16 16.657 16 15V10H21C21.5525 10 22 10.4475 22 11ZM19 8C20.1045 8 21 7.1045 21 6C21 4.8955 20.1045 4 19 4C17.8955 4 17 4.8955 17 6C17 7.1045 17.8955 8 19 8Z" fill="#2A858F" />
			<path d="M17.5 11V16.5C17.5 19.3715 15.0795 21.678 12.167 21.489C9.5095 21.317 7.5 18.9915 7.5 16.3285V10H16.5C17.0525 10 17.5 10.4475 17.5 11ZM12.5 8.5C14.157 8.5 15.5 7.157 15.5 5.5C15.5 3.843 14.157 2.5 12.5 2.5C10.843 2.5 9.5 3.843 9.5 5.5C9.5 7.157 10.843 8.5 12.5 8.5Z" fill="#4CBBC7" />
			<path d="M12.5 8.5C14.1569 8.5 15.5 7.15685 15.5 5.5C15.5 3.84315 14.1569 2.5 12.5 2.5C10.8431 2.5 9.5 3.84315 9.5 5.5C9.5 7.15685 10.8431 8.5 12.5 8.5Z" fill="#4CBBC7" />
			<path
				d="M13 16.6595V10H7.5V16.3285C7.5 17.0955 7.6715 17.8325 7.972 18.5H11.159C12.176 18.5 13 17.676 13 16.6595Z"
				fill="black"
				opacity="0.05"
			/>
			<path
				d="M7.5 10V16.3285C7.5 16.9085 7.6005 17.4705 7.777 18H11.106C11.968 18 12.6665 17.3015 12.6665 16.4395V10H7.5Z"
				fill="black"
				opacity="0.07"
			/>
			<path
				d="M12.3335 10H7.5V16.3285C7.5 16.7295 7.5505 17.1205 7.637 17.5H11.053C11.76 17.5 12.333 16.927 12.333 16.22V10H12.3335Z"
				fill="black"
				opacity="0.09"
			/>
			<path d="M11 17H3C2.4475 17 2 16.5525 2 16V8C2 7.4475 2.4475 7 3 7H11C11.5525 7 12 7.4475 12 8V16C12 16.5525 11.5525 17 11 17Z" fill="#2A858F" />
			<path d="M9.03382 9.49951H4.96582V10.3595H6.48932V14.4995H7.51032V10.3595H9.03382V9.49951Z" fill="white" />
		</SvgIcon>
	);
};

const SeaBreeze = () => {
	return (
		<SvgIcon viewBox="0 0 24 24">
			<path d="M22 11V15C22 16.657 20.657 18 19 18C17.343 18 16 16.657 16 15V10H21C21.5525 10 22 10.4475 22 11ZM19 8C20.1045 8 21 7.1045 21 6C21 4.8955 20.1045 4 19 4C17.8955 4 17 4.8955 17 6C17 7.1045 17.8955 8 19 8Z" fill="#2A858F" />
			<path d="M17.5 11V16.5C17.5 19.3715 15.0795 21.678 12.167 21.489C9.5095 21.317 7.5 18.9915 7.5 16.3285V10H16.5C17.0525 10 17.5 10.4475 17.5 11ZM12.5 8.5C14.157 8.5 15.5 7.157 15.5 5.5C15.5 3.843 14.157 2.5 12.5 2.5C10.843 2.5 9.5 3.843 9.5 5.5C9.5 7.157 10.843 8.5 12.5 8.5Z" fill="#4CBBC7" />
			<path d="M12.5 8.5C14.1569 8.5 15.5 7.15685 15.5 5.5C15.5 3.84315 14.1569 2.5 12.5 2.5C10.8431 2.5 9.5 3.84315 9.5 5.5C9.5 7.15685 10.8431 8.5 12.5 8.5Z" fill="#4CBBC7" />
			<path
				d="M13 16.6595V10H7.5V16.3285C7.5 17.0955 7.6715 17.8325 7.972 18.5H11.159C12.176 18.5 13 17.676 13 16.6595Z"
				fill="black"
				opacity="0.05"
			/>
			<path
				d="M7.5 10V16.3285C7.5 16.9085 7.6005 17.4705 7.777 18H11.106C11.968 18 12.6665 17.3015 12.6665 16.4395V10H7.5Z"
				fill="black"
				opacity="0.07"
			/>
			<path
				d="M12.3335 10H7.5V16.3285C7.5 16.7295 7.5505 17.1205 7.637 17.5H11.053C11.76 17.5 12.333 16.927 12.333 16.22V10H12.3335Z"
				fill="black"
				opacity="0.09"
			/>
			<path d="M11 17H3C2.4475 17 2 16.5525 2 16V8C2 7.4475 2.4475 7 3 7H11C11.5525 7 12 7.4475 12 8V16C12 16.5525 11.5525 17 11 17Z" fill="#2A858F" />
			<path d="M9.03382 9.49951H4.96582V10.3595H6.48932V14.4995H7.51032V10.3595H9.03382V9.49951Z" fill="white" />
		</SvgIcon>
	);
};

const Spearmint = () => {
	return (
		<SvgIcon viewBox="0 0 24 24">
			<path d="M22 11V15C22 16.657 20.657 18 19 18C17.343 18 16 16.657 16 15V10H21C21.5525 10 22 10.4475 22 11ZM19 8C20.1045 8 21 7.1045 21 6C21 4.8955 20.1045 4 19 4C17.8955 4 17 4.8955 17 6C17 7.1045 17.8955 8 19 8Z" fill="#218043" />
			<path d="M17.5 11V16.5C17.5 19.3715 15.0795 21.678 12.167 21.489C9.5095 21.317 7.5 18.9915 7.5 16.3285V10H16.5C17.0525 10 17.5 10.4475 17.5 11ZM12.5 8.5C14.157 8.5 15.5 7.157 15.5 5.5C15.5 3.843 14.157 2.5 12.5 2.5C10.843 2.5 9.5 3.843 9.5 5.5C9.5 7.157 10.843 8.5 12.5 8.5Z" fill="#52C47A" />
			<path d="M12.5 8.5C14.1569 8.5 15.5 7.15685 15.5 5.5C15.5 3.84315 14.1569 2.5 12.5 2.5C10.8431 2.5 9.5 3.84315 9.5 5.5C9.5 7.15685 10.8431 8.5 12.5 8.5Z" fill="#52C47A" />
			<path
				d="M13 16.6595V10H7.5V16.3285C7.5 17.0955 7.6715 17.8325 7.972 18.5H11.159C12.176 18.5 13 17.676 13 16.6595Z"
				fill="black"
				opacity="0.05"
			/>
			<path
				d="M7.5 10V16.3285C7.5 16.9085 7.6005 17.4705 7.777 18H11.106C11.968 18 12.6665 17.3015 12.6665 16.4395V10H7.5Z"
				fill="black"
				opacity="0.07"
			/>
			<path
				d="M12.3335 10H7.5V16.3285C7.5 16.7295 7.5505 17.1205 7.637 17.5H11.053C11.76 17.5 12.333 16.927 12.333 16.22V10H12.3335Z"
				fill="black"
				opacity="0.09"
			/>
			<path d="M11 17H3C2.4475 17 2 16.5525 2 16V8C2 7.4475 2.4475 7 3 7H11C11.5525 7 12 7.4475 12 8V16C12 16.5525 11.5525 17 11 17Z" fill="#218043" />
			<path d="M9.03382 9.49951H4.96582V10.3595H6.48932V14.4995H7.51032V10.3595H9.03382V9.49951Z" fill="white" />
		</SvgIcon>
	);
};

const StarryNight = () => {
	return (
		<SvgIcon viewBox="0 0 24 24">
			<path d="M22 11V15C22 16.657 20.657 18 19 18C17.343 18 16 16.657 16 15V10H21C21.5525 10 22 10.4475 22 11ZM19 8C20.1045 8 21 7.1045 21 6C21 4.8955 20.1045 4 19 4C17.8955 4 17 4.8955 17 6C17 7.1045 17.8955 8 19 8Z" fill="#2D76D4" />
			<path d="M17.5 11V16.5C17.5 19.3715 15.0795 21.678 12.167 21.489C9.5095 21.317 7.5 18.9915 7.5 16.3285V10H16.5C17.0525 10 17.5 10.4475 17.5 11ZM12.5 8.5C14.157 8.5 15.5 7.157 15.5 5.5C15.5 3.843 14.157 2.5 12.5 2.5C10.843 2.5 9.5 3.843 9.5 5.5C9.5 7.157 10.843 8.5 12.5 8.5Z" fill="#61A7F2" />
			<path d="M12.5 8.5C14.1569 8.5 15.5 7.15685 15.5 5.5C15.5 3.84315 14.1569 2.5 12.5 2.5C10.8431 2.5 9.5 3.84315 9.5 5.5C9.5 7.15685 10.8431 8.5 12.5 8.5Z" fill="#61A7F2" />
			<path
				d="M13 16.6595V10H7.5V16.3285C7.5 17.0955 7.6715 17.8325 7.972 18.5H11.159C12.176 18.5 13 17.676 13 16.6595Z"
				fill="black"
				opacity="0.05"
			/>
			<path
				d="M7.5 10V16.3285C7.5 16.9085 7.6005 17.4705 7.777 18H11.106C11.968 18 12.6665 17.3015 12.6665 16.4395V10H7.5Z"
				fill="black"
				opacity="0.07"
			/>
			<path
				d="M12.3335 10H7.5V16.3285C7.5 16.7295 7.5505 17.1205 7.637 17.5H11.053C11.76 17.5 12.333 16.927 12.333 16.22V10H12.3335Z"
				fill="black"
				opacity="0.09"
			/>
			<path d="M11 17H3C2.4475 17 2 16.5525 2 16V8C2 7.4475 2.4475 7 3 7H11C11.5525 7 12 7.4475 12 8V16C12 16.5525 11.5525 17 11 17Z" fill="#2D76D4" />
			<path d="M9.03382 9.49951H4.96582V10.3595H6.48932V14.4995H7.51032V10.3595H9.03382V9.49951Z" fill="white" />
		</SvgIcon>
	);
};

const SunsetBoulevard = () => {
	return (
		<SvgIcon viewBox="0 0 24 24">
			<path d="M22 11V15C22 16.657 20.657 18 19 18C17.343 18 16 16.657 16 15V10H21C21.5525 10 22 10.4475 22 11ZM19 8C20.1045 8 21 7.1045 21 6C21 4.8955 20.1045 4 19 4C17.8955 4 17 4.8955 17 6C17 7.1045 17.8955 8 19 8Z" fill="#D14030" />
			<path d="M17.5 11V16.5C17.5 19.3715 15.0795 21.678 12.167 21.489C9.5095 21.317 7.5 18.9915 7.5 16.3285V10H16.5C17.0525 10 17.5 10.4475 17.5 11ZM12.5 8.5C14.157 8.5 15.5 7.157 15.5 5.5C15.5 3.843 14.157 2.5 12.5 2.5C10.843 2.5 9.5 3.843 9.5 5.5C9.5 7.157 10.843 8.5 12.5 8.5Z" fill="#ED7A6D" />
			<path d="M12.5 8.5C14.1569 8.5 15.5 7.15685 15.5 5.5C15.5 3.84315 14.1569 2.5 12.5 2.5C10.8431 2.5 9.5 3.84315 9.5 5.5C9.5 7.15685 10.8431 8.5 12.5 8.5Z" fill="#ED7A6D" />
			<path
				d="M13 16.6595V10H7.5V16.3285C7.5 17.0955 7.6715 17.8325 7.972 18.5H11.159C12.176 18.5 13 17.676 13 16.6595Z"
				fill="black"
				opacity="0.05"
			/>
			<path
				d="M7.5 10V16.3285C7.5 16.9085 7.6005 17.4705 7.777 18H11.106C11.968 18 12.6665 17.3015 12.6665 16.4395V10H7.5Z"
				fill="black"
				opacity="0.07"
			/>
			<path
				d="M12.3335 10H7.5V16.3285C7.5 16.7295 7.5505 17.1205 7.637 17.5H11.053C11.76 17.5 12.333 16.927 12.333 16.22V10H12.3335Z"
				fill="black"
				opacity="0.09"
			/>
			<path d="M11 17H3C2.4475 17 2 16.5525 2 16V8C2 7.4475 2.4475 7 3 7H11C11.5525 7 12 7.4475 12 8V16C12 16.5525 11.5525 17 11 17Z" fill="#D14030" />
			<path d="M9.03382 9.49951H4.96582V10.3595H6.48932V14.4995H7.51032V10.3595H9.03382V9.49951Z" fill="white" />
		</SvgIcon>
	);
};

const VioletMist = () => {
	return (
		<SvgIcon viewBox="0 0 24 24">
			<path d="M22 11V15C22 16.657 20.657 18 19 18C17.343 18 16 16.657 16 15V10H21C21.5525 10 22 10.4475 22 11ZM19 8C20.1045 8 21 7.1045 21 6C21 4.8955 20.1045 4 19 4C17.8955 4 17 4.8955 17 6C17 7.1045 17.8955 8 19 8Z" fill="#6B65A8" />
			<path d="M17.5 11V16.5C17.5 19.3715 15.0795 21.678 12.167 21.489C9.5095 21.317 7.5 18.9915 7.5 16.3285V10H16.5C17.0525 10 17.5 10.4475 17.5 11ZM12.5 8.5C14.157 8.5 15.5 7.157 15.5 5.5C15.5 3.843 14.157 2.5 12.5 2.5C10.843 2.5 9.5 3.843 9.5 5.5C9.5 7.157 10.843 8.5 12.5 8.5Z" fill="#8984B9" />
			<path d="M12.5 8.5C14.1569 8.5 15.5 7.15685 15.5 5.5C15.5 3.84315 14.1569 2.5 12.5 2.5C10.8431 2.5 9.5 3.84315 9.5 5.5C9.5 7.15685 10.8431 8.5 12.5 8.5Z" fill="#8984B9" />
			<path
				d="M13 16.6595V10H7.5V16.3285C7.5 17.0955 7.6715 17.8325 7.972 18.5H11.159C12.176 18.5 13 17.676 13 16.6595Z"
				fill="black"
				opacity="0.05"
			/>
			<path
				d="M7.5 10V16.3285C7.5 16.9085 7.6005 17.4705 7.777 18H11.106C11.968 18 12.6665 17.3015 12.6665 16.4395V10H7.5Z"
				fill="black"
				opacity="0.07"
			/>
			<path
				d="M12.3335 10H7.5V16.3285C7.5 16.7295 7.5505 17.1205 7.637 17.5H11.053C11.76 17.5 12.333 16.927 12.333 16.22V10H12.3335Z"
				fill="black"
				opacity="0.09"
			/>
			<path d="M11 17H3C2.4475 17 2 16.5525 2 16V8C2 7.4475 2.4475 7 3 7H11C11.5525 7 12 7.4475 12 8V16C12 16.5525 11.5525 17 11 17Z" fill="#6B65A8" />
			<path d="M9.03382 9.49951H4.96582V10.3595H6.48932V14.4995H7.51032V10.3595H9.03382V9.49951Z" fill="white" />
		</SvgIcon>
	);
};

const iconMap: Record<string, FunctionComponent> = {
	ArcticFresh: ArcticFresh,
	CentricBlue: CentricBlue,
	DragonFruit: DragonFruit,
	Dusk: Dusk,
	Indigo: Indigo,
	Luxe: Luxe,
	OceanWave: OceanWave,
	SeaBreeze: SeaBreeze,
	Spearmint: Spearmint,
	StarryNight: StarryNight,
	SunsetBoulevard: SunsetBoulevard,
	VioletMist: VioletMist,
};

interface MSTeamsIconIndicatorProps extends SvgIconProps { }

const MSTeamsIconIndicator: FunctionComponent<MSTeamsIconIndicatorProps> = (props) => {
	const { color } = props;
	const isSelected = (color === "primary");
	const { sessionStore, routerStore } = useStore();
	const { skinTheme } = sessionStore;
	const { locationNode } = routerStore;
	const skin = xml.enumGetText(skinTheme);
	const mono = !locationNode.MSTeamsChannels?.length;
	let TeamsIndicator: (() => Element) | FunctionComponent = GrayscaleIcon;

	if (isSelected) {
		TeamsIndicator = iconMap[skin] || TeamsIndicator;
	}

	return mono ? <TeamsIndicator /> : <ConnectedIcon props={props} />;
};

export default MSTeamsIconIndicator;